import { lazyWithPreload } from "./lazyWithPreload";

export const ScriptPanel = lazyWithPreload(() =>
  import("components/dashboard/body/projects").then((m) => ({ default: m.ScriptPanel }))
);

export const ScriptEditorPanel = lazyWithPreload(() =>
  import("features/script-editor").then((m) => ({
    default: m.ScriptEditor,
  }))
);

export const SnapshotDetailPanel = lazyWithPreload(() =>
  import("features/script-editor/snapshot-detail").then((m) => ({
    default: m.SnapshotDetailPanel,
  }))
);

export const ScriptSnapshotComparePanel = lazyWithPreload(() =>
  import("features/script-editor/snapshot-compare").then((m) => ({
    default: m.SnapshotComparePanel,
  }))
);

export const OutlinePanel = lazyWithPreload(() =>
  import("features/script-editor/outline").then((m) => ({
    default: m.OutlinePanel,
  }))
);

export const SharedScriptPage = lazyWithPreload(() =>
  import("features/script-editor/share").then((m) => ({
    default: m.SharedScriptPage,
  }))
);

export const NotesPanel = lazyWithPreload(() =>
  import("pages/dashboard/projects/script/notes").then((m) => ({
    default: m.NotesPage,
  }))
);

export const TagsPanel = lazyWithPreload(() =>
  import("pages/dashboard/projects/script/tags").then((m) => ({
    default: m.TagsPage,
  }))
);

export const ReportPanel = lazyWithPreload(() =>
  import("pages/dashboard/projects/script/report").then((m) => ({
    default: m.ReportPage,
  }))
);

export const CoveragePanel = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/coverage").then((m) => ({
    default: m.CoveragePanel,
  }))
);

export const CharacterSummaryPanel = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/character/components/CharacterSummaryPanel").then(
    (m) => ({
      default: m.CharacterSummaryPanel,
    })
  )
);

export const CharacterBreakdownPanel = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/character/components/CharacterBreakdownPanel").then(
    (m) => ({
      default: m.CharacterBreakdownPanel,
    })
  )
);

export const Stripboard = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/schedule/Stripboard").then((m) => ({
    default: m.Stripboard,
  }))
);

export const DayOutOfDays = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/schedule/DayOutOfDays").then((m) => ({
    default: m.DayOutOfDays,
  }))
);

export const ShootingCalendar = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/schedule/ShootingCalendar").then((m) => ({
    default: m.ShootingCalendar,
  }))
);

export const RoadmapBoard = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/schedule/RoadmapBoard").then((m) => ({
    default: m.RoadmapBoard,
  }))
);

export const ActorsManagementPanel = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/actors/ActorsManagementPanel").then((m) => ({
    default: m.ActorsManagementPanel,
  }))
);

export const TaxIncentives = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/budget/TaxIncentives/TaxIncentives").then(
    (m) => ({ default: m.TaxIncentives })
  )
);

export const Fringes = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/budget/Fringes").then((m) => ({
    default: m.Fringes,
  }))
);

export const Actuals = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/budget/Actuals").then((m) => ({
    default: m.Actuals,
  }))
);

export const Budget = lazyWithPreload(() =>
  import("components/dashboard/body/projects/panels/budget/Budget").then((m) => ({
    default: m.Budget,
  }))
);
